const DIRECTION = {
  BACK: -1,
  NEXT_OR_SUBMIT: 1,
};

export default DIRECTION;
